<template>
    <div class="pt-4">
        <h3 class="col-span-2 text-base font-semibold">
            {{ $t('country_tax_residencies.tax_residency') }}
        </h3>
        <div class="divide-y divide-gray-300">
            <div v-for="(tin, index) in formValues" :key="index">
                <TaxResidencyRow
                    v-model:country="tin.country"
                    v-model:no_tin_reason="tin.no_tin_reason"
                    v-model:tin="tin.tin"
                    :index="index"
                    @remove="removeRow(index)" />
            </div>
        </div>
    </div>
    <div>
        <BaseButtonPrimary :disabled="reachedTinLimit" @click="addRow()">
            <PlusIcon class="mr-2 w-6"></PlusIcon>
            {{ $t('country_tax_residencies.add_another_tax_residence') }}
        </BaseButtonPrimary>
    </div>
</template>

<script setup lang="ts">
import TaxResidencyRow from '../../form/TaxResidencyRow.vue'
import { computed, onMounted, onUnmounted } from 'vue'
import { TaxResidency } from '../../../../../utilities/account/useAccountDataPersonal'
import BaseButtonPrimary from '../../../../base/BaseButtonPrimary.vue'
import { PlusIcon } from '@heroicons/vue/outline'
import { useVModel } from '@vueuse/core'
import { initializeLegalWidgetForm } from './forms'
import { clearIncompleteTaxResidencies, getTinValidationRules } from '../../../../../validation'

const props = defineProps<{
    modelValue: TaxResidency[]
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)

const reachedTinLimit = computed(() => {
    return formValues.value.length >= 5
})

function removeRow(index) {
    formValues.value.splice(index, 1)
}

onMounted(() => {
    if (formValues.value.length === 0) {
        addRow()
    }
})

onUnmounted(() => {
    formValues.value = clearIncompleteTaxResidencies(formValues.value)
})
function addRow() {
    formValues.value.push(new TaxResidency())
}

initializeLegalWidgetForm({ tin: getTinValidationRules() })
</script>

<style scoped></style>
